import { render } from "./OvertimeDetail.vue?vue&type=template&id=1daae198"
import script from "./OvertimeDetail.vue?vue&type=script&lang=js"
export * from "./OvertimeDetail.vue?vue&type=script&lang=js"

import "./OvertimeDetail.vue?vue&type=style&index=0&id=1daae198&lang=css"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__